
import React from 'react';
import { NavLink } from 'react-router-dom';



import {
  DashboardIcon,
  InsightsIcon,
  ReportsIcon,
} from '../../../components/ui/AppIcon';

const ModeIcons = {
  'DashboardIcon': DashboardIcon,
  'InsightsIcon': InsightsIcon,
  'ReportsIcon': ReportsIcon
};


const Factory = ( model, rolePermissions, user, setIsSidebarOpen, metadata ) => {
  return (
    <>
      {(() => {

        if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
          return '';
        }

        const NavItemIcon = ModeIcons[ model.handle.Icon ];

        return (
          <NavLink
            className={({ isActive }) => `sidebar-link${isActive ? ' is-active' : ''}`}
            key={'/' + model.handle.section}
            onClick={() => setIsSidebarOpen(false)}
            to={'/' + model.handle.section}
          >
            <NavItemIcon className="nav-icon" />
            <span>{model.handle.title}</span>
          </NavLink>
        );
      })()}

      <p className="sidebar-nav-label">Workspace</p>

      {model.identity.map((item) => {

        if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
          return '';
        }

        const NavItemIcon = ModeIcons[ item.Icon ];

        return (
          <NavLink
            className={({ isActive }) => `sidebar-link${isActive ? ' is-active' : ''}`}
            key={'/' + item.section}
            onClick={() => setIsSidebarOpen(false)}
            to={'/' + item.section}
          >
            <NavItemIcon className="nav-icon" />
            <span>{item.title}</span>
          </NavLink>
        );
      })}
    </>
  );

};


export default Factory;